const APPLICATIONS = [
  {
    titleKo: "이차전지 전극 롤프레스",
    titleEn: "Battery Electrode Roll Press",
    desc: "전극 공정의 정밀 롤 갭·하중·압력 제어",
    icon: "ri-battery-charge-line",
    img: "https://readdy.ai/api/search-image?query=Industrial%20battery%20electrode%20roll%20press%20machine%20with%20polished%20stainless%20steel%20rollers%20and%20thin%20copper%20foil%20web%20running%20through%2C%20clean%20modern%20factory%20interior%2C%20bright%20neutral%20lighting%2C%20no%20text%20no%20logos%20no%20labels%2C%20editorial%20industrial%20photography%2C%20muted%20steel%20gray%20and%20cool%20blue%20palette&width=800&height=600&seq=mctech-appl-battery-2026&orientation=landscape",
  },
  {
    titleKo: "필름·시트 롤프레스",
    titleEn: "Film & Sheet Roll Press",
    desc: "필름과 시트의 두께 및 장력 정밀 제어",
    icon: "ri-file-shred-line",
    img: "https://readdy.ai/api/search-image?query=Industrial%20film%20and%20sheet%20roll%20press%20with%20heated%20chrome%20rollers%20and%20transparent%20polymer%20film%20web%2C%20clean%20modern%20factory%20interior%2C%20bright%20neutral%20lighting%2C%20no%20text%20no%20logos%20no%20labels%2C%20editorial%20industrial%20photography%2C%20muted%20steel%20gray%20palette&width=800&height=600&seq=mctech-appl-film-2026&orientation=landscape",
  },
  {
    titleKo: "정밀 압연·캘린더링 장비",
    titleEn: "Precision Calendering System",
    desc: "다양한 소재의 균일한 압연과 품질 제어",
    icon: "ri-contract-up-down-line",
    img: "https://readdy.ai/api/search-image?query=Industrial%20precision%20calendering%20machine%20with%20large%20steel%20rollers%20pressing%20uniform%20material%20sheet%2C%20clean%20modern%20factory%20interior%2C%20bright%20neutral%20lighting%2C%20no%20text%20no%20logos%20no%20labels%2C%20editorial%20industrial%20photography%2C%20muted%20steel%20gray%20palette&width=800&height=600&seq=mctech-appl-calender-2026&orientation=landscape",
  },
  {
    titleKo: "기존 장비 서보유압 개조",
    titleEn: "Servo Hydraulic Retrofit",
    desc: "유압·센서·모션제어 시스템 개선 및 시운전",
    icon: "ri-water-flash-line",
    img: "https://readdy.ai/api/search-image?query=Industrial%20servo%20hydraulic%20system%20retrofit%20installation%20on%20existing%20machinery%20with%20servo%20valves%20and%20hydraulic%20hoses%20connected%20to%20cylinder%2C%20clean%20modern%20factory%20interior%2C%20bright%20neutral%20lighting%2C%20no%20text%20no%20logos%20no%20labels%2C%20editorial%20industrial%20photography%2C%20muted%20steel%20gray%20and%20cool%20blue%20palette&width=800&height=600&seq=mctech-appl-retrofit-2026&orientation=landscape",
  },
];

export default function IndustriesSection() {
  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center max-w-2xl mx-auto mb-12 md:mb-16">
          <span className="inline-flex items-center gap-2 text-[11px] font-semibold tracking-[0.2em] uppercase text-accent-700 mb-3">
            <span className="w-6 h-px bg-accent-500" />
            Roll Press & Servo Hydraulic Applications
            <span className="w-6 h-px bg-accent-500" />
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-extrabold text-foreground-950 leading-tight">
            <span className="text-primary-700">주요 적용 분야</span>
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-700 leading-relaxed">
            MC TECH가 실제로 제공하는 롤프레스와 서보유압 정밀 제어 업무에 집중된 적용 분야입니다.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {APPLICATIONS.map((it) => (
            <article
              key={it.titleKo}
              className="group bg-background-100 border border-background-200 rounded-xl overflow-hidden hover:border-primary-300 transition-colors"
            >
              <div className="relative h-48 bg-background-200 overflow-hidden">
                <img
                  src={it.img}
                  alt={it.titleKo}
                  className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-primary-950/40 via-transparent to-transparent" />
                <div className="absolute top-3 left-3 w-10 h-10 rounded-md bg-background-50/95 backdrop-blur flex items-center justify-center">
                  <i className={`${it.icon} text-lg w-5 h-5 flex items-center justify-center text-primary-700`} />
                </div>
              </div>
              <div className="p-5">
                <p className="text-[11px] font-medium tracking-wide uppercase text-secondary-500">
                  {it.titleEn}
                </p>
                <h3 className="mt-1 text-base md:text-lg font-heading font-bold text-foreground-950">
                  {it.titleKo}
                </h3>
                <p className="mt-2 text-sm md:text-base text-foreground-700 leading-relaxed">
                  {it.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}